import { cn } from '@shared/lib/cn'
import { LocalizedLink as Link, type LocalizedLinkProps } from '@shared/lib/locale'

import styles from './styles.module.scss'

export default function LinkChip (props: LocalizedLinkProps) {
  const { children, className } = props

  return (
    <Link className={cn(styles.root, className)} {...props}>
      {children}
    </Link>
  )
}
